module.exports = __webpack_public_path__ + "static/media/adrien_new.61e53d69.jpg";